import { render, staticRenderFns } from "./ListaAPI.vue?vue&type=template&id=7a50c080&scoped=true&"
import script from "./ListaAPI.vue?vue&type=script&lang=js&"
export * from "./ListaAPI.vue?vue&type=script&lang=js&"
import style0 from "./ListaAPI.vue?vue&type=style&index=0&id=7a50c080&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a50c080",
  null
  
)

export default component.exports